/* eslint-disable prefer-template */
import { format } from "date-fns";
import moment from "moment";

import { Timezone } from "../models/timezone";

export function formatDate(value: string) {
  if (value) return moment(value).format("DD/MM/YYYY");

  return value;
}

export function compareDate(date1: Date, date2: Date) {
  /*
             -1              0              1
        date1 > date2  date1 == date2 date1 < date2
   */
  if (date1 > date2) return -1;
  if (date2 > date1) return 1;

  return 0;
}

export function getAmPmHour(time: string) {
  // eslint-disable-next-line prefer-const
  let [hour, minute] = time.split(":");

  if (Number(hour) > 12) {
    hour = (Number(hour) - 12).toString();

    return `${Number(hour) > 9 ? hour : "0" + Number(hour)}:${minute}pm`;
  }

  return `${Number(hour) > 9 ? hour : "0" + Number(hour)}:${minute}am`;
}

export function formatSecondsToMinutes(seconds: number) {
  const date = new Date(seconds * 1000).toISOString().substr(11, 8);

  return date;
}

export function formatTimezone(timezone?: Timezone): string {
  if (timezone && timezone?.gmtOffset && timezone?.nameFormatted) {
    return `GMT (${formatGMT(timezone?.gmtOffset)}) ${timezone?.nameFormatted
      ?.replace("/", " / ")
      .replace("_", "")}`;
  }

  return "";
}

export function formatGMT(gmt: number) {
  let gmtFormatted = "";

  if (gmt > 0) {
    gmtFormatted += "+";
    if (gmt >= 10) gmtFormatted += gmt + ":00";
    else gmtFormatted += "0" + gmt + ":00";
  } else if (gmt < 0) {
    gmtFormatted += "-";
    if (gmt <= -10) gmtFormatted += Math.abs(gmt) + ":00";
    else gmtFormatted += "0" + Math.abs(gmt) + ":00";
  } else {
    gmtFormatted += "+00:00";
  }

  return gmtFormatted;
}

export const formatDateWithoutTimeZone = (date?: string, addTime?: boolean) => {
  if (!date) return "";

  const [dateClean, time] = date.split("T");
  const valueSplitted = dateClean?.split("-");
  let dateFormated = "";

  if (valueSplitted && valueSplitted.length === 3) {
    const year = valueSplitted[0];
    const month = valueSplitted[1];
    const day = valueSplitted[2];

    dateFormated = `${day}/${month}/${year}`;
  }

  if (addTime) {
    const [hour, minute] = time.split(":");

    return format(new Date(date).setHours(Number(hour), Number(minute)), "dd/MM/yyy HH:mm a");
  }

  return dateFormated;
};

export const formatTimeWithoutTimeZone = (date?: string) => {
  if (!date) return null;

  const [hour, minute, second = "00"] = date.split(":");

  return format(new Date().setHours(Number(hour), Number(minute), Number(second)), "HH:mm a");
};

export const rejectNonNumbers = (value: string) => value.replace(/\D/, "");

export const capitalizeFirstCharacter = (value: string) => {
  if (!value || value.length === 0) {
    return value || "";
  }

  return value.charAt(0).toUpperCase() + value.slice(1);
};
